<div class="select-edit-row">
  <input #inputCheck
         class="server-name"
         value="{{inputValue}}"
         [disabled]="inputIsDisable"
         [hidden]="inputIsHidden"/>

  <div class="modify-live-search" [hidden]="!inputIsHidden">
    <ngx-select [allowClear]="true"
                [items]="allHttpModeOptions"
                (select)="selectedHttpMode($event)">
    </ngx-select>
  </div>

  <div class="select-edit-btn-area">
    <i *ngIf="isAdmin"
       class="fa fa-edit transition text-tooltip"
       aria-hidden="true"
       title-popup="Edit"
       (click)="inputOnClick()"
       [hidden]="inputIsHidden"></i>

    <button class="transition text-tooltip tooltip-edit"
            [hidden]="!inputIsHidden"
            (click)="inputOnSave()"
            [disabled]="hasError"
            title-popup="Save">
      <i class="fa fa-check"
         [ngClass]="{'disabled':hasError}"
         aria-hidden="true"></i>
    </button>

    <button class="transition text-tooltip tooltip-edit"
            title-popup="Cancel"
            [hidden]="!inputIsHidden"
            (click)="inputOnCancel(inputCheck)">
      <i class="fa fa-times"
         aria-hidden="true"></i>
    </button>
  </div>
</div>

<div class="alert alert-danger alert-validate error-validate"
     *ngIf="hasError">{{errorMessage}}
</div>

